import utils from 'utils'

class creatDeclarationDetailCtrl {
    constructor($scope, $stateParams, $timeout) {
        const obj = JSON.parse(utils.decode($stateParams.obj))
        const fileName = `${obj.periodName}-${obj.flzlmc}`
        $(() => {
            $('body').addClass('leftnav-close ie11-overflow')
            $('#wrapper').addClass('top-nav-close')
        })
        if (obj.movement == 'write') {
            if (obj.type && obj.type == 'incomeTax') {
                $scope.url = encodeURI(`${host.etcloudBiReport}ReportServer?reportlet=${obj.path}&op=${obj.movement}&ZLBSCJUUID=${obj.sbuuid}&flzlxh=${obj.item}&__filename__=${fileName}`)
            } else {
                $scope.url = encodeURI(`${host.etcloudBiReport}ReportServer?reportlet=${obj.path}&op=${obj.movement}&sbuuid=${obj.sbuuid}&flzlxh=${obj.item}&__filename__=${fileName}`)
            }
        } else {
            if (obj.type && obj.type == 'incomeTax') {
                $scope.url = encodeURI(`${host.etcloudBiReport}ReportServer?reportlet=${obj.path}&op=${obj.movement}&ZLBSCJUUID=${obj.sbuuid}&__filename__=${fileName}`)
            } else {
                $scope.url = encodeURI(`${host.etcloudBiReport}ReportServer?reportlet=${obj.path}&op=${obj.movement}&sbuuid=${obj.sbuuid}&__filename__=${fileName}`)
            }

            const index = obj.item - 1
            //    console.log(obj);
            $timeout(() => {
                const iframe = document.querySelector('#creatDeclarationDetail')
                iframe.attachEvent = iframe.attachEvent || 0
                if (iframe.attachEvent) {
                    iframe.attachEvent('onload', () => {
                        const document = iframe.contentDocument || iframe.contentWindow.document
                        $(document.querySelectorAll('.fr-sheetbutton-middlepart'))[index].click()
                    })
                } else {
                    iframe.onload = function () {
                        const document = iframe.contentDocument || iframe.contentWindow.document
                        $(document.querySelectorAll('.fr-sheetbutton-middlepart'))[index].click()
                    }
                }
            })
        }
    }
}

creatDeclarationDetailCtrl.$inject = ['$scope', '$stateParams', '$timeout']
export default creatDeclarationDetailCtrl



// WEBPACK FOOTER //
// ./src/app/declaration/addValTaxDeclaration/creatDeclaration/creatDeclarationDetailCtrl.js